module.exports = __webpack_public_path__ + "static/group4_1-e660997b2dadc7be252e6c20ff60dd11.webp";